(function(window, document, $, ajaxlib, appconfig, Diff) {
    /* jshint validthis: true */
    'use strict';
    var _baseURL = appconfig.baseURL;
    var _baseURLMedia = appconfig.baseURLMedia;
    var _autosave_base_data = {};
    var _timer = null;
    var _user = {};
    var dt = null;
    var _dt_loading = false;
    var _prevDiffPreview = '';
    var _global_modal = undefined;
    var _is_not_dirty = true;
    var c = {
        unmark: 'warning',
        mark: 'warning',
        view_accept: 'primary',
        view: 'primary',
        accept: 'info',
        edit: 'warning',
        release: 'danger',
        archive: 'danger',
        flag: 'danger',
        amend: 'info',
        download: 'success',
        ftp: 'success',
        lftp: 'info',
        rftp: 'warning'
    };
    var d = {
        flagged: ['danger', 'mdi mdi-flag'],
        accepted: ['info', 'mdi mdi-account-check'],
        edited: ['warning', 'mdi mdi-pencil-lock'],
        pending: ['danger', 'mdi mdi-verified'],
        published: ['success', 'mdi mdi-spellcheck']
    }
    var _current_active = 'new';
    var _visited_mark_new = false;
    var _visited_mark_flag = false;
    var _visited_mark_pending = false;
    var _visited_mark_accepted = false;
    var _visited_mark_email = false;
    var currentNewStories = 0;
    var currentPendingStories = 0;
    var currentFlaggedStories = 0;
    var currentEmailStories = 0;
    var _is_inactive = false;
    var _is_initial = true;
    var _last_played = 0;
    var _delay = 60 * 1000;
    var _delay_multiplier = 1;
    var _myswal = null;
    var _root_tmpdata = null;


    function __disp_block(options) {
        var _options = {
            title: 'Untitled Modal',
            confirmButtonText: 'Confirm',
            cancelTitle: 'Operation Cancelled',
            failedText: 'Operation Failed',
            successTitle: 'Operation Successful',
            successText: 'Operation completed successfully',
            redirectHomePage: false,
            successCallback: function(d) {},
            errorCallback: function(err) {},
            cancelCallback: function() {}
        };
        options = Object.assign(_options, options);
        if (options.path === undefined) {
            throw ("'path' is needed");
        }
        _myswal({
            title: options.title,
            showCancelButton: true,
            confirmButtonText: options.confirmButtonText,
            showLoaderOnConfirm: true,
            allowOutsideClick: function() { return !_myswal.isLoading(); },
        }).then(function(result) {
            if (result.dismiss === _myswal.DismissReason.cancel || result.dismiss === _myswal.DismissReason.backdrop) {
                _myswal(
                    options.cancelTitle,
                    'User cancelled the operation',
                    'error'
                );
                options.cancelCallback();
            } else {
                return ajaxlib.AJAX(options.path, ajaxlib.fetchAuthHeader()).Post().then(function(data) {
                    toastr.success(data.message);
                    _myswal(
                        options.successTitle,
                        options.successText,
                        'success'
                    );
                    options.successCallback(data);
                    _reload_current(options.redirectHomePage);
                }).catch(function(err) {
                    _myswal(
                        options.failedText,
                        err.detail,
                        'error'
                    );
                    options.errorCallback(err);
                });
            }
        });
    }

    function __get_uuid(e) {
        try {
            e.preventDefault();
            e.stopPropagation();
        } catch (err) {}
        try {
            var uuid = $(e.target).data('id');
            var sep = $(e.target).data('sep');
        } catch (err) {}
        if (uuid === undefined) {
            uuid = e;
        }
        if (sep !== undefined) {
            return uuid.split(sep)[0];
        }
        return uuid;
    }

    try {
        _myswal = swal.mixin({
            animation: false,
            customClass: 'animated slideInUp',
            buttonsStyling: false,
            cancelButtonClass: 'btn btn-warning mx-1',
            confirmButtonClass: 'btn btn-primary mx-1'
        });
    } catch (e) {}

    $(window).blur(function() {
        _is_inactive = true;
    });
    $(window).focus(function() {
        _is_inactive = false;
        _delay_multiplier = 1;
    });

    // Configure toastr
    try {
        toastr.options = {
            "closeButton": true,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": true,
            "timeOut": "2000",
        };
    } catch (e) {}

    function _notify(check) {
        check = check ? true : false;
        var to_play = !check;
        if (check && ((Date.now() - _last_played) >= _delay * _delay_multiplier)) {
            to_play = true;
            _delay_multiplier++;
        }
        if (to_play) {
            try {
                $('#notification')[0].play();
                _last_played = Date.now();
            } catch (e) {}
        }
    }

    function _toggle_blocking_loader(html) {
        if ($('[data-loader="body"]')[0] === undefined) {
            var loader = $('<div data-loader="body"></div>');
            loader.append('<div class="loader-container">' + html + '</div>');
            $('body').append(loader);
        } else {
            $('[data-loader="body"]').remove();
        }
    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(c) {
            return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
    }

    function _set_dt(_dt) {
        console.log('Setup DT');
        dt = _dt;
    }

    function mark_current_active() {
        $('[data-type="cards"]').removeClass('active');
        $('[data-id="' + applib.getCurrentActive() + '"]').addClass('active');
    }

    function _start_dt_loader() {
        console.log($('[data-dt-loader]'));
        $('[data-dt-loader]').addClass('active');
        $('[data-hide]').addClass('d-none');
        _dt_loading = true;
    }

    function _stop_dt_loader() {
        console.log($('[data-dt-loader]'));
        $('[data-dt-loader]').removeClass('active');
        $('[data-hide]').removeClass('d-none');
        _dt_loading = false;
    }

    function render_stat(no_reload) {
        no_reload = no_reload ? true : false;
        return function(data) {
            data = data.data;
            var old_new = false;
            var has_new = false;
            //var star = '<i class="mdi mdi-star-circle text-danger"></i>&nbsp;';
            if (data.new_stories > 0 && applib.getMarkNew()) {
                $('[data-id="new-stories"]').html(applib.padn(data.new_stories)).addClass('active');
                old_new = true;
            } else {
                $('[data-id="new-stories"]').text(applib.padn(data.new_stories)).removeClass('active');
            }
            if (data.flagged_stories > 0 && applib.getMarkFlag() && _user.group !== "PT") {
                $('[data-id="flagged-stories"]').html(applib.padn(data.flagged_stories)).addClass('active');
                old_new = true;
            } else {
                $('[data-id="flagged-stories"]').text(applib.padn(data.flagged_stories)).removeClass('active');
            }
            if (data.pending_stories > 0 && applib.getMarkPending()) {
                $('[data-id="pending-stories"]').html(applib.padn(data.pending_stories)).addClass('active');
                old_new = true;
            } else {
                $('[data-id="pending-stories"]').text(applib.padn(data.pending_stories)).removeClass('active');
            }
            if (data.dashboard_pending_stories > 0 ) {
                $('[data-id="dashboard-pending-stories"]').html(applib.padn(data.dashboard_pending_stories)).addClass('active');
                old_new = true;
            } else {
                $('[data-id="dashboard-pending-stories"]').text(applib.padn(data.dashboard_pending_stories)).removeClass('active');
                
            }
            if (data.accepted_stories > 0 && applib.getMarkAccepted()) {
                $('[data-id="accepted-stories"]').text(applib.padn(data.accepted_stories)).addClass('active');
            } else {
                $('[data-id="accepted-stories"]').text(applib.padn(data.accepted_stories)).removeClass('active');
            }
            if (data.email_stories > 0 && applib.getMarkEmail()) {
                $('[data-id="created_by_email-stories"]').text(applib.padn(data.email_stories)).addClass('active');
            } else {
                $('[data-id="created_by_email-stories"]').text(applib.padn(data.email_stories)).removeClass('active');
            }
            $('[data-id="completed-stories"]').text(applib.padn(data.completed_stories)).removeClass('active');
            if (data.new_stories > currentNewStories) {
                $('[data-id="new-stories"]').html(applib.padn(data.new_stories)).addClass('active');
                toastr.success("New Stories maybe available");
                has_new = true;
            }
            if (data.pending_stories > currentPendingStories) {
                $('[data-id="pending-stories"]').html(applib.padn(data.pending_stories)).addClass('active');
                toastr.success("Stories maybe pending for Review");
                has_new = true;
            }
            if (data.flagged_stories > currentFlaggedStories) {
                $('[data-id="flagged-stories"]').html(applib.padn(data.flagged_stories)).addClass('active');
                toastr.error("Some Stories are Flagged");
                has_new = true;
            }

            currentNewStories = data.new_stories;
            currentPendingStories = data.pending_stories;
            currentFlaggedStories = data.flagged_stories;
            currentEmailStories = data.email_stories;

            if (!no_reload && has_new) {
                applib.reloadCurrent();
            }
            if (has_new && !_is_initial) {
                _notify();
            } else if (old_new && _is_inactive && !_is_initial) {
                _notify(true);
            }
            _is_initial = false;
        };
    }

    function _match_status(e) {
        var rk = Object.keys(d).join("|");
        var reg = new RegExp(rk, 'i');
        try {
            var o = (e.match(reg) || [""]).pop().toLowerCase();
            return (d[o] || ["", ""]);
        } catch (err) {}
        return ["", ""];
    }

    function _has_flag(e) {
        return (e ? e.toLowerCase() === 'flagged' : false);
    }

    function _get_actions(entry) {
        var act = ['view'];
        try {
            if (_user.group !== 'PT') {
                if (entry.user_created_by.username === _user.username && entry.edit_hash === null) {
                    act = act.concat(['amend', 'archive']);
                }
                
                if (!(entry.current_flag === 'PT_PUBLISHED' || entry.current_flag === 'CE_PUBLISHED' || entry.current_flag === 'HE_PUBLISHED')) {
                    if (entry.edit_hash === null) {
                        act.push('edit');
                    } 
                    if (_user.username === entry.user_accepted_by.username) {
                        act.push('release');
                    }
                }

                if (_user.is_superuser && act.indexOf('release') === -1) {
                    act.push('release');
                }
            } else if (entry.get_status.toUpperCase().search('PUBLISHED') !== -1) {
                act = act.concat(['download', 'webpublish']);
                act.push((entry.has_tried_upload ? 'rftp' : 'ftp'));
            }
            if (_user.is_superuser && act.indexOf('archive') === -1 && entry.edit_hash === null) {
                act.push('archive')
            }

            act.push((entry.is_new ? 'mark' : 'unmark'));
        } catch (err) {
            console.error(err);
        }

        return act;
    }

    function render_dt(d_type, silent) {
        silent = silent ? true : false;
        _current_active = d_type;
        return function(data) {
            data = data.data;
            var row_map = data.map(function(entry, i) {
                try {
                    var btns = '<div class="btn-group dropdown">' +
                        '<a href="javascript: void(0);" class="dropdown-toggle arrow-none btn btn-light btn-sm" data-toggle="dropdown" aria-expanded="false"><i class="mdi mdi-dots-horizontal"></i></a>' +
                        '<div class="dropdown-menu dropdown-menu-right">';
                    _get_actions(entry).forEach(function(e) {
                        btns += applib.getBtn(entry.uuid, e, c[e]);
                    });
                    btns += '</div></div>';
                    return [
                        '<b class="id"># ' + applib.padn(i + 1) + '</b>',
                        entry.is_new,
                        _has_flag(entry.get_status),
                        '<p style="cursor:pointer" data-id="' + entry.uuid + '" data-action="view">' + (entry.summary.substring(0, 140) + (entry.summary.length > 140 ? '...' : '')) + '</p>' +
                        ((entry.title !== null && entry.title !== '') ? '<p style="border: 1px solid #ccc;padding: 0.2rem 0.4rem;background: #fff;" data-id="' + entry.uuid + '">' + (entry.title.substring(0, 140)) + (entry.title.length > 140 ? '...' : '') + '</p>' : ''),
                        '<img src="static/intradmin/assets/images/users/avatar-2.jpg" alt="contact-img" height="36" title="contact-img" class="rounded-circle float-left mr-2" />' +
                        '<p class="mb-0 font-weight-bold"><a href="javascript: void(0);">' +
                        ((entry.user_created_by.first_name + " " + entry.user_created_by.last_name).trim() ? (entry.user_created_by.first_name + " " + entry.user_created_by.last_name) : entry.user_created_by.username) +
                        '</a></p>' +
                        '<span class="font-13">' + entry.user_created_by.email + '</span>',
                        entry.get_status ? '<div class="p-2 badge badge-' + _match_status(entry.get_status)[0] + '">' +
                        '<span class="' + _match_status(entry.get_status)[1] + '"></span>&nbsp;' +
                        (entry.has_uploaded && entry.current_flag === 'PT_PUBLISHED' ? 'Uploaded' : entry.get_status) +
                        '</div>' : '--',
                        '<span class="prettydate">' + entry.last_modified_on + '</span>',
                        btns,
                        entry.short_desc,
                        entry.keywords,
                    ];
                } catch (err) {
                    console.log(err);
                }
            });
            dt.clear().rows([]).draw();
            row_map.forEach(function(row) {
                if (row === undefined || row === null || !Array.isArray(row)) { return false; }
                try {
                    var is_new = row[1];
                    var has_flag = row[2];
                    var n_row = dt.row.add(row).draw().node();
                    if (has_flag) {
                        $(n_row).addClass('flagged');
                    } else if (is_new) {
                        $(n_row).addClass('new');
                    }
                } catch (err) {}
            });

            try {
                $('.prettydate').prettydate();
            } catch (e) {}
            _setup_listener();
            if (!silent) {
                toastr.success("Stories Loaded");
            }
            mark_current_active();
            _stop_dt_loader();
        };
    }

    function _setup_listener(_cb) {
        _cb = typeof _cb === 'function' ? _cb : function(uuid) {};
        $('[data-action="view_accept"]').off().on('click', applib.viewStory(true));
        $('[data-action="view"]').off().on('click', applib.viewStory(false));
        $('[data-action="edit"]').off().on('click', applib.editStory);
        $('[data-action="release"]').off().on('click', applib.releaseStory);
        $('[data-action="mark"]').off().on('click', applib.markRead);
        $('[data-action="unmark"]').off().on('click', applib.markUnread);
        $('[data-action="approve"]').off().on('click', applib.markApproved);
        $('[data-action="accept"]').off().on('click', applib.publishStory);
        $('[data-action="review"]').off().on('click', applib.sendStoryToPool);
        $('[data-action="amend"]').off().on('click', applib.amendStory);
        $('[data-action="flag"]').off().on('click', applib.flagStory);
        $('[data-action="archive"]').off().on('click', applib.archiveStory);
        $('[data-action="remove_inline"]').off().on('click', applib.removeInlineImage(_cb));
        $('[data-action="download"]').off().on('click', applib.prepareDownload);
        $('[data-action="webpublish"]').off().on('click', applib.publishToANI);
        $('[data-action="ftp"],[data-action="rftp"],[data-action="lftp"]').off().on('click', applib.sendFTP);
        $('[data-action="add-additional"]').off().on('click', applib.addAdditional);
        // Add Context Menu Right Click Feature
        $('[data-action="view"]').on('contextmenu', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var uuid = __get_uuid(e);
            _redirect_view(uuid, true);
        });
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function _get_btn(uuid, btn_type, _cls) {
        var btn_text = btn_type == 'view_accept' ? 'View & Accept' : btn_type;
        btn_text = btn_text == 'mark' ? 'Mark Read' : btn_text;
        btn_text = btn_text == 'unmark' ? 'Mark Unread' : btn_text;
        btn_text = btn_text == 'ftp' ? 'Upload to FTP' : btn_text;
        btn_text = btn_text == 'lftp' ? '<i class="mdi mdi-spin mdi-loading"></i> Uploading' : btn_text;
        btn_text = btn_text == 'rftp' ? 'Re Upload to FTP' : btn_text;
        btn_text = btn_text == 'webpublish' ? 'Publish to ANI' : btn_text

        var locked = btn_type === 'lftp' ? true : false;
        var href = '#';

        var btn_obj = '<a class="dropdown-item" href="' + href + '" data-id="' + uuid + '" data-action="' + btn_type + '" data-disabled="' + locked.toString + '"><i class="mdi mdi-' + _cls + ' mr-1 text-muted"></i>' + capitalize(btn_text) + '</a>';

        return btn_obj;
    }

    function _padn(n) {
        return n > 9 ? "" + n : "0" + n;
    }

    function _redirect_login() {
        _trylogout(function() {
            ajaxlib.resetToken().then(function() {
                window.location.href = appconfig.loginPath + window.location.search;
            });
        });
    }

    function _refresh_page() {
        toastr.success("Content Updated");
        window.location.reload();
    }

    function _redirect_view(uuid, new_tab) {
        new_tab = new_tab || false;
        if (new_tab) {
            var win = window.open('/view/' + uuid + '/', '_blank');
            win.focus();
        } else {
            window.location.href = '/view/' + uuid + '/';
        }
    }

    function _redirect_page(baseURL) {
        return function(data) {
            var path = data.data;
            window.location.href = baseURL.replace(/\/+$/, '') + '/' + path.replace(/\/+$/, '') + (path.trim() === '' ? '' : '/');
        };
    }

    function _redirect_dashboard() {
        // Check if next param is setup in query string then redirect there
        var nextEntry = window.location.search.replace(/^\?/, '').split('&').map(function(entry) {
            var sp = entry.trim().split('=');
            try {
                return [sp[0], sp[1]];
            } catch (err) {}
        }).filter(function(entry) { return entry[0].toLowerCase() === 'next'; });
        if (nextEntry.length !== 0) {
            window.location.href = nextEntry[0][1];
        } else {
            window.location.href = appconfig.homePath;
        }
    }

    function _redirect_media_dashboard() {
        // Check if next param is setup in query string then redirect there
        var nextEntry = window.location.search.replace(/^\?/, '').split('&').map(function(entry) {
            var sp = entry.trim().split('=');
            try {
                return [sp[0], sp[1]];
            } catch (err) {}
        }).filter(function(entry) { return entry[0].toLowerCase() === 'next'; });
        if (nextEntry.length !== 0) {
            window.location.href = nextEntry[0][1];
        } else {
            window.location.href = appconfig.mediaPath;
        }
    }

    function _redirect_ani_dashboard() {
        // Check if next param is setup in query string then redirect there
        var nextEntry = window.location.search.replace(/^\?/, '').split('&').map(function(entry) {
            var sp = entry.trim().split('=');
            try {
                return [sp[0], sp[1]];
            } catch (err) {}
        }).filter(function(entry) { return entry[0].toLowerCase() === 'next'; });
        if (nextEntry.length !== 0) {
            window.location.href = nextEntry[0][1];
        } else {
            window.location.href = appconfig.aniAdminPath;
        }
    }

    function _show_error(err) {
        console.log(err);
        _stop_dt_loader();
        toastr.error((err || { detail: 'Some Error Occured' }).detail);
    }

    function _show_toast(msg) {
        _stop_dt_loader();
        toastr.success(msg);
    }

    function _show_login_error(err) {
        try {
            $('[data-error]').removeClass('d-none').html('<b>' + err.non_field_errors[0] + '</b>');
            $('[data-loading]').addClass('d-none').parents('button').first().removeClass('disabled');
        } catch (err) {}
        toastr.error("Invalid Credentials");
    }

    function _login(_cb, _fail) {
        _cb = _cb || _redirect_dashboard;
        _fail = _fail || _show_login_error;
        return function(e) {
            var frmData = $(e.target).serializeArray();
            var postData = {};
            e.preventDefault();
            e.stopPropagation();
            try {
                $('[data-error]').addClass('d-none').html("");
                $('[data-loading]').removeClass('d-none').parents('button').first().addClass('disabled');
            } catch (err) {}
            frmData.forEach(function(element) {
                postData[element.name] = element.value;
            });

            ajaxlib.AJAX(_baseURL + '/user/login/', ajaxlib.fetchAuthHeader(true)).Post(postData).then(function(data) {
                ajaxlib.setToken(data.token).then(_cb).catch(_show_error);
            }).catch(_fail);
        };
    }

    function _trylogout(_callback) {
        ajaxlib.AJAX(_baseURL + '/user/logout/', ajaxlib.fetchAuthHeader()).Post().then(_callback).then(_redirect_login).catch(_callback);
    }

    function _logout(e) {
        ajaxlib.AJAX(_baseURL + '/user/logout/', ajaxlib.fetchAuthHeader()).Post().then(ajaxlib.resetToken).then(_redirect_login).catch(_show_error);
    }

    function _load_data(_map) {
        ajaxlib.AJAX(_baseURL + '/stories/stats/', ajaxlib.fetchAuthHeader()).Get().then(_map).catch(_show_error);
    }

    function _fetch_stories(_map, silent) {
        silent = silent ? true : false;
        return function(e) {
            _start_dt_loader();
            var did = __get_uuid(e);
            setTimeout(function() {
                ajaxlib.AJAX(_baseURL + '/stories/' + did + '/', ajaxlib.fetchAuthHeader()).Get().then(function(data) {
                    _current_active = did;
                    if (did === 'new') {
                        _visited_mark_new = true;
                    } else if (did === 'flagged') {
                        _visited_mark_flag = true;
                    } else if (did === 'pending') {
                        _visited_mark_pending = false;
                    } else if (did == 'accepted') {
                        _visited_mark_accepted = true;
                    }
                    _map(did, silent)(data);
                }).catch(_show_error);
            }, 50);
        };
    }

    function _reload_current(checkHome) {
        checkHome = checkHome ? true : false;
        //_reset_marks();
        if (checkHome & window.location.pathname !== '/') {
            _redirect_dashboard();
        } else if (window.location.pathname !== '/') {
            window.location.reload();
        } else {
            _load_data(render_stat(true));
            _fetch_stories(render_dt, true)(_current_active);
        }
    }

    function _mark_invalid(input) {
        input.classList.add('swal2-inputerror');
        $(input).off().one('keypress', function(e) {
            this.classList.remove('swal2-inputerror');
            document.getElementById('swal2-validationerror').style = 'display:none';
        });
    }

    function _add_additional(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/additional/keys/', ajaxlib.fetchAuthHeader()).Get()
            .then(function(data) {
                var d = data.data;
                var kl = '';
                d.forEach(function(e) {
                    kl += '<option value="' + e.p_key + ';' + e.p_type + '">' + e.p_name + '</option>';
                });
                _myswal.queue([{
                    title: 'Add Additional Data',
                    html: '<select class="swal2-select" style="width:100%;" id="swal-skey">' +
                        kl +
                        '</select>',
                    showCancelButton: true,
                    confirmButtonText: 'Next',
                    showLoaderOnConfirm: true,
                    preConfirm: function() {
                        var keyBlock = document.getElementById('swal-skey').value.split(';');
                        var key = keyBlock[0];
                        var type = keyBlock[1];

                        return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/additional/keys/options?p_key=' + key, ajaxlib.fetchAuthHeader()).Get()
                            .then(function(data) {
                                var htm = '';
                                var d = data.data;
                                var kl = '';
                                d.forEach(function(e) {
                                    kl += '<option value="' + e.p_slug + '">' + e.p_verbose + '</option>';
                                });
                                if (type === 'S' || type === 'M') {
                                    htm = '<div style="display:inline-block;padding-top:21px;">';
                                    htm += '<select class="swal2-select" style="width:100%;" id="swal-sdata" ' + (type === 'M' ? 'multiple' : '') + '/>' +
                                        kl +
                                        '</select>';
                                    htm += '</div>';
                                } else {
                                    htm += '<input class="swal2-input" style="width:100%;" id="swal-sdata" value=""/>';
                                }

                                return _myswal.insertQueueStep({
                                    title: 'Add Additional Data',
                                    html: htm,
                                    showCancelButton: true,
                                    confirmButtonText: 'Add Data',
                                    showLoaderOnConfirm: true,
                                    onBeforeOpen: function(modal) {
                                        try {
                                            if (type === 'M') {
                                                $('#swal-sdata').multiSelect();
                                            }
                                        } catch (err) {}
                                    },
                                    preConfirm: function() {
                                        var data = $('#swal-sdata').val().join(',');
                                        if (data.trim() === '') {
                                            _mark_invalid(document.getElementById('swal-sdata'));
                                            _myswal.showValidationError('Please Enter the Data');
                                        } else if (data.trim().length > 350) {
                                            _mark_invalid(document.getElementById('swal-sdata'));
                                            _myswal.showValidationError('Data too long for field');
                                        } else {
                                            return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/additional/add/', ajaxlib.fetchAuthHeader()).Post({
                                                'key': key.trim(),
                                                'data': data.trim()
                                            }).then(function(response) {
                                                return response;
                                            }).catch(function(err) {
                                                _myswal.showValidationError(
                                                    'Request failed: ' + err.detail
                                                );
                                            });
                                        }
                                    },
                                    allowOutsideClick: function() { return !_myswal.isLoading(); },
                                });
                            }).catch(function(err) {
                                console.error(err);
                                _myswal.showValidationError(
                                    'Request failed: ' + err.detail
                                );
                            });
                    },
                    allowOutsideClick: function() { return !_myswal.isLoading(); },
                }]).then(function(result) {
                    console.log(result);
                    if (result.dismiss === _myswal.DismissReason.cancel || result.dismiss === _myswal.DismissReason.backdrop) {
                        _show_error({ detail: 'User Cancelled Operation' });
                    } else {
                        toastr.success('Additional Data Added');
                        _refresh_page();
                    }
                });
            })
            .catch(_show_error);
    }

    function _create_story(e) {
        e.preventDefault();
        e.stopPropagation();
        ajaxlib.AJAX(_baseURL + '/stories/categories/', ajaxlib.fetchAuthHeader()).Get().then(function(data) {
            data = data.data;

            var html = '';
            Object.keys(data).forEach(function(key) {
                html += '<option value="' + key + '">' + data[key] + '</option>';
            });
            _myswal({
                title: 'Create New Story',
                html: '<select class="swal2-select" id="swal-category" style="width:100%;">' +
                    html +
                    '</select>' +
                    '<textarea class="swal2-textarea" id="swal-story"></textarea>' +
                    '<div class="custom-control custom-checkbox">' +
                    '<input class="custom-control-input" id="assign_me" type="checkbox">' +
                    '<label class="custom-control-label" for="assign_me">Assign to me</label>' +
                    '</div>',
                showCancelButton: true,
                confirmButtonText: 'Create Story',
                showLoaderOnConfirm: true,
                preConfirm: function() {
                    var summary = document.getElementById('swal-story').value;
                    var category = document.getElementById('swal-category').value;
                    var assign_me = document.getElementById('assign_me').checked;
                    if (summary.trim() === '') {
                        _mark_invalid(document.getElementById('swal-story'));
                        _myswal.showValidationError('Please Enter a short Summary');
                    } else if (summary.trim().length > 1500) {
                        _mark_invalid(document.getElementById('swal-story'));
                        _myswal.showValidationError('Summary is too long. Please reduce the summary size. Max Length: 1500 Characters');
                    } else {
                        return ajaxlib.AJAX(_baseURL + '/stories/create/', ajaxlib.fetchAuthHeader()).Post({
                            'summary': summary.trim(),
                            'category': category,
                            'assign_me': assign_me
                        }).then(function(response) {
                            return response;
                        }).catch(function(err) {
                            _myswal.showValidationError(
                                'Request failed: ' + err.detail
                            );
                        });
                    }
                },
                allowOutsideClick: function() { return !_myswal.isLoading(); },
            }).then(function(result) {
                if (result.dismiss === _myswal.DismissReason.cancel || result.dismiss === _myswal.DismissReason.backdrop) {
                    _myswal(
                        'Story not Created!',
                        'User cancelled the operation',
                        'error'
                    );
                } else {
                    _myswal(
                        'Story Created!',
                        'The Story is created and sent to Sub-Editors',
                        'success'
                    );
                    _reload_current();
                }
            });
        }).catch(_show_error);
    }

    function _get_str(data) {
        return data ? data : 'N/A';
    }

    function _cbf(options) {
        var _options = Object.apply({
            'type': 'Flagged',
            'successText': 'The Story is flagged and sent to Editor'
        }, options);
        return function(result) {
            if (result.dismiss === _myswal.DismissReason.cancel || result.dismiss === _myswal.DismissReason.backdrop) {
                _myswal(
                    'Story not ' + _options.type + '!',
                    'User cancelled the operation',
                    'error'
                );
            } else {
                _myswal(
                    'Story ' + _options.type + '!',
                    _options.successText,
                    'success'
                );
                _reload_current();
            }
        };
    }

    function _disp_amend_modal(data) {
        data = data.data;
        _myswal({
            title: 'Amend Story <small class="d-block"><b>UUID:</b>&nbsp;' + data.uuid + '</small>',
            input: 'textarea',
            inputValue: data.summary,
            inputPlaceholder: 'Enter a short summary',
            inputValidator: function(value) {
                return new Promise(function(resolve) {
                    if (value.trim() === '') {
                        resolve('Please Enter a short Summary');
                    } else if (value.trim() === data.summary.trim()) {
                        resolve('No changes made');
                    } else {
                        resolve('');
                    }
                });
            },
            showCancelButton: true,
            confirmButtonText: 'Amend Story',
            showLoaderOnConfirm: true,
            preConfirm: function(summary) {
                return ajaxlib.AJAX(_baseURL + '/stories/' + data.uuid + '/amend/', ajaxlib.fetchAuthHeader()).Post({
                    'summary': summary.trim()
                }).then(function(response) {
                    return response;
                }).catch(function(err) {
                    _myswal.showValidationError(
                        'Request failed: ' + err.detail
                    );
                });
            },
            allowOutsideClick: function() { return !_myswal.isLoading(); },
        }).then(_cbf({
            'type': 'Amended',
            'successText': 'The Story is amended successfully'
        }));
    }

    function _disp_modal(accept, mode) {
        mode = mode ? 'view_mode' : 'accept_mode';
        console.log(mode);
        return function(data) {
            data = data.data;
            console.log(data);
            if (data.accepted_by !== null) {
                mode = 'view_mode';
                accept = true;
                console.log(data.accepted_by, mode);
            }
            var html = '<div class="row">' +
                '<div class="col-12">' +
                '<table class="table">' +
                '<tr>' +
                '<th colspan="4">Summary</th>' +
                '</tr>' +
                '<tr>' +
                '<td colspan="4">' + data.summary + '</td>' +
                '</tr>' +
                '<tr>' +
                '<th>Posted By</th>' +
                '<th>Posted On</th>' +
                '<th>Edited By</th>' +
                '<th>Edited On</th>' +
                '</tr>' +
                '<tr>' +
                '<td>' +
                '<p class="mb-0 font-weight-bold"><a href="javascript: void(0);">' +
                ((data.user_created_by.first_name + " " + data.user_created_by.last_name).trim() ? (data.user_created_by.first_name + " " + data.user_created_by.last_name) : data.user_created_by.username) +
                '</a></p>' +
                '<span class="font-13">' + data.user_created_by.email + '</span></td>' +
                '<td class="prettydate">' + data.created_on + '</td>' +
                '<td>' +
                (_get_str(data.user_edited_by.username) === 'N/A' ? 'N/A' :
                    '<p class="mb-0 font-weight-bold"><a href="javascript: void(0);">' +
                    ((data.user_edited_by.first_name + " " + data.user_edited_by.last_name).trim() ? (data.user_edited_by.first_name + " " + data.user_edited_by.last_name) : data.user_edited_by.username) +
                    '</a></p>' +
                    '<span class="font-13">' + data.user_edited_by.email + '</span>'
                ) +
                '</td>' +
                '<td class="prettydate">' + _get_str(data.last_modified_on) + '</td>' +
                '</tr>' +
                '</table>' +
                '</div>' +
                '</div>';
            _myswal({
                title: 'Story <small class="d-block"><b>UUID:</b>&nbsp;' + data.uuid + '</small>',
                width: '90vw',
                html: html,
                showCancelButton: true,
                showConfirmButton: accept,
                cancelButtonText: 'Close',
                confirmButtonText: (mode === 'accept_mode' ? 'Accept' : 'View Detail'),
                onBeforeOpen: function() {
                    try {
                        $('.prettydate').prettydate();
                        $('.swal2-confirm').on('contextmenu', function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            _redirect_view(data.uuid, true);
                        });
                    } catch (e) {}
                }
            }).then(function(result) {
                if (result.value && accept && mode === 'accept_mode') {
                    return _accept_story(data.uuid);
                } else if (result.value && mode === 'view_mode') {
                    _redirect_view(data.uuid);
                }
            });
        };
    }

    function _view_story(accept) {
        accept = accept ? true : false;
        return function(e) {
            var uuid = __get_uuid(e);

            ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/', ajaxlib.fetchAuthHeader()).Get().then(_disp_modal(accept)).catch(function(err) {
                _myswal(
                    'Error',
                    err.detail,
                    'error'
                );
            });
        };
    }

    function _amend_story(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/', ajaxlib.fetchAuthHeader()).Get().then(_disp_amend_modal).catch(function(err) {
            _myswal(
                'Error',
                err.detail,
                'error'
            );
        });
    }

    function _accept_story(e) {
        var uuid = __get_uuid(e);

        __disp_block({
            title: 'Accept Story',
            confirmButtonText: 'Accept Story',
            cancelTitle: 'Story not Accepted!',
            failedText: 'Failed to Accept!',
            successTitle: 'Story Accepted!',
            successText: 'The Story is accepted successfully',
            path: _baseURL + '/stories/' + uuid + '/accept/'
        });
    }

    function _edit_story(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/edit/', ajaxlib.fetchAuthHeader()).Post().then(function(data) {
            window.location.href = '/edit/' + uuid + '/';
        }).catch(_show_error);
    }

    function _release_story(e) {
        var uuid = __get_uuid(e);

        __disp_block({
            title: 'Release Story: Back to Pool',
            confirmButtonText: 'Release',
            cancelTitle: 'Story not Released!',
            failedText: 'Failed to Release!',
            successTitle: 'Story Released!',
            successText: 'The Story is released successfully',
            path: _baseURL + '/stories/' + uuid + '/release/'
        });
    }

    function _publish_to_ani(e) {
        var uuid = __get_uuid(e);

        __disp_block({
            title: 'Publish to ANI Website',
            confirmButtonText: 'Publish',
            cancelTitle: 'Story not Published!',
            failedText: 'Failed to Publish!',
            successTitle: 'Story Published!',
            successText: 'The Story is published successfully',
            redirectHomePage: true,
            path: _baseURL + '/stories/' + uuid + '/webpublish/'
        });
    }

    function _archive_story(e) {
        var uuid = __get_uuid(e);

        __disp_block({
            title: 'Archive/Delete Story',
            confirmButtonText: 'Archive/Delete',
            cancelTitle: 'Story not Archived!',
            failedText: 'Failed to Archive!',
            successTitle: 'Story Archived!',
            successText: 'The Story is archived successfully',
            path: _baseURL + '/stories/' + uuid + '/archive/'
        });
    }

    function _mark_read(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/mark/read/', ajaxlib.fetchAuthHeader()).Post().then(function(data) {
            toastr.success(data.message);
            _reload_current();
        }).catch(_show_error);
    }

    function _mark_unread(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/mark/unread/', ajaxlib.fetchAuthHeader()).Post().then(function(data) {
            toastr.success(data.message);
            _reload_current();
        }).catch(_show_error);
    }

    function _mark_approved(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/mark/approved/', ajaxlib.fetchAuthHeader()).Post().then(function(data) {
            toastr.success(data.message);
            _refresh_page();
        }).catch(_show_error);
    }

    function _check_status(uuid, v) {
        return function() {
            return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/' + v + '/push/status/', ajaxlib.fetchAuthHeader()).Post().then(function(response) {
                console.error(response)
                if (response.data.status === false) {
                    setTimeout(_check_status(uuid, v), 2000);
                } else {
                    if (response.data.error === false) {
                        toastr.success(response.message);
                    } else {
                        toastr.error(response.message);
                    }
                    _toggle_blocking_loader('Done');
                    _reload_current(true);
                }
            }).catch(function(err) {
                console.log(err);
            });
        };
    }

    function _send_ftp(e) {
        var uuid = __get_uuid(e);

        if ($(e.target).data('disabled') == 'true') {
            toastr.error("Story Already in Queue to be uploaded");
            return false;
        }
        _myswal({
            title: 'Upload Story to FTP',
            showCancelButton: true,
            confirmButtonText: 'Upload to FTP',
            showLoaderOnConfirm: true,
            allowOutsideClick: function() { return !_myswal.isLoading(); },
        }).then(function(result) {
            if (result.dismiss === _myswal.DismissReason.cancel || result.dismiss === _myswal.DismissReason.backdrop) {
                _myswal(
                    'Story not Uploaded to FTP!',
                    'User cancelled the operation',
                    'error'
                );
            } else {
                return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/push/init/', ajaxlib.fetchAuthHeader()).Post().then(function(response) {
                    toastr.success('The Story is queued to be uploaded successfully');
                    _reload_current(false);
                    _toggle_blocking_loader('<i class="mdi mdi-spin mdi-loading"></i> Uploading in Progress');
                    setTimeout(_check_status(uuid, response.data), 2000);
                }).catch(function(err) {
                    _myswal(
                        'Failed to Upload Story to FTP!',
                        err.detail,
                        'error'
                    );
                });
            }
        });
    }

    function _remove_image(parent, _cb) {
        return function() {
            parent.remove();
            try {
                return _cb();
            } catch (err) { console.error(err); }
        };
    }

    function _remove_inline_image(_cb) {
        var _wrapperFn = function(uuid) {
            return function() {
                return _cb(uuid);
            };
        };
        return function(e) {
            var parent = $(e.target).parents('.js-iimp').first();
            var uuid = __get_uuid(e);
            var _fn = _wrapperFn(uuid);
            ajaxlib.AJAX(_baseURL + '/images/' + uuid + '/delete/', ajaxlib.fetchAuthHeader()).Post().then(_remove_image(parent, _fn)).catch(_show_error);
        };
    }

    function _get_diff_footer() {
        return '<button class="btn btn-outline-info" data-action="local-copy"><i class="mdi mdi-database"></i>&nbsp;<b>Use Local</b></button>&nbsp;' +
            '<button class="btn btn-outline-primary" data-action="server-copy"><i class="mdi mdi-server"></i>&nbsp;<b>Use Server</b></button>' +
            '<button class="btn btn-outline-success" data-action="merge"><i class="mdi mdi-source-merge"></i>&nbsp;<b>Merge Changes from Local</b></button>' +
            '<button class="btn btn-outline-warning" data-action="merge-rev"><i class="mdi mdi-source-merge"></i>&nbsp;<b>Merge Changes from Server</b></button>';
    }

    function _update_preview(previewBlk, newContent) {
        return new Promise(function(_callback) {
            _start_dt_loader();
            setTimeout(function() {
                $(previewBlk).addClass('d-none');
                $(previewBlk).html(newContent);
                _stop_dt_loader();
                $(previewBlk).removeClass('d-none');
                _callback(true);
            }, 250);
        });
    }

    function _enable_apply_and_revert(previewBlk, newContent, uuid) {
        _update_preview(previewBlk, newContent).then(function() {
            $('[data-id="action-blk"]').removeClass('d-none');
        });

        $('[data-action="merge-revert"]').off().on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            _update_preview(previewBlk, _prevDiffPreview).then(function() {
                $('[data-id="action-blk"]').addClass('d-none');
            });
        });

        $('[data-action="merge-apply"]').off().on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            ajaxlib.setLocalKey(uuid, newContent).then(function() {
                try {
                    _autosave_base_data.story = newContent;
                    try {
                        var ed = window.tinymce.get("tinyEditor");
                        ed.setContent(newContent);
                        try {
                            _global_modal.modal('hide');
                            _global_modal = undefined;
                        } catch (err) {}
                    } catch (err) {}
                } catch (err) {}
                $('[data-id="action-blk"]').addClass('d-none');
            });
        });
    }

    function _use_cp_handler(uuid, story, previewBlk) {
        return function(e) {
            e.preventDefault();
            e.stopPropagation();
            _enable_apply_and_revert(previewBlk, story, uuid);
        }
    }

    function _use_merge_handler(uuid, storyOld, storyNew, previewBlk) {
        return function(e) {
            e.preventDefault();
            e.stopPropagation();
            try {
                var patch = Diff.createPatch('s2s.patch', storyNew, storyOld);
                console.log(patch);
                var patchedStory = Diff.applyPatch(storyNew, patch);
                console.log(patchedStory);
                if (patchedStory) {
                    _enable_apply_and_revert(previewBlk, patchedStory, uuid);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    function _setup_diff_listener(uuid, localStory, serverStory, previewBlk) {
        // Store Old Data
        _prevDiffPreview = $(previewBlk).html();
        $('[data-action="local-copy"]').off().on('click', _use_cp_handler(uuid, localStory, previewBlk));
        $('[data-action="server-copy"]').off().on('click', _use_cp_handler(uuid, serverStory, previewBlk));
        $('[data-action="merge"]').off().on('click', _use_merge_handler(uuid, localStory, serverStory, previewBlk));
        $('[data-action="merge-rev"]').off().on('click', _use_merge_handler(uuid, serverStory, localStory, previewBlk));
    }

    function _fill_form(data, uuid) {
        data = data.data;
        Object.keys(data).forEach(function(key) {
            $('[data-id="' + key + '"]').val(data[key]);
        });
        _autosave_base_data = data;

        return new Promise(function(_cb) {
            // Get Working Local Copy
            ajaxlib.getLocalKey(uuid).then(function(localStory) {
                var serverStory = data.story;
                try {
                    var ed = window.tinymce.get("tinyEditor");
                    ed.once('SetContent', function() {
                        serverStory = ed.getContent();
                        if (localStory === null) {
                            ajaxlib.setLocalKey(uuid, serverStory);
                            _cb(data);
                        } else {
                            var _differ = _init_diff(serverStory, localStory, true);
                            _differ.execute().then(function(diff) {
                                if (diff.length) {
                                    // There's a different copy in local; Let's prompt User
                                    _global_modal = _open_modal({
                                            title: '<i class="mdi mdi-source-branch"></i>&nbsp;<b>Local Changes Available</b>',
                                            body: '<div class="pb-2 d-flex flex-row justify-content-between">' +
                                                '<p>There are some local changes available</p><div class="d-none" data-id="action-blk">' +
                                                '<button data-action="merge-revert" class="btn btn-warning"><i class="mdi mdi-undo"></i>&nbsp;<b>Revert</b></button>&nbsp;' +
                                                '<button data-action="merge-apply" class="btn btn-success"><i class="mdi mdi-check-circle"></i>&nbsp;<b>Apply</b></button>' +
                                                '</div></div><div id="diff-blk"></div>',
                                            needFooter: true,
                                            customFooter: _get_diff_footer()
                                        }).modal({
                                            backdrop: 'static',
                                            keyboard: true,
                                            focus: true,
                                            show: true
                                        })
                                        .on('shown.bs.modal', function() {
                                            _pretty_print_diff('#diff-blk')(diff).then(function() {
                                                _setup_diff_listener(uuid, localStory, serverStory, '#content-preview');
                                            });
                                        })
                                        .on('hidden.bs.modal', function(e) {
                                            $(this).remove();
                                            _cb(_autosave_base_data);
                                        });
                                } else {
                                    // Set Working Local Copy
                                    ajaxlib.setLocalKey(uuid, serverStory);
                                    _cb(data);
                                }
                            });
                        }
                    });
                    ed.setContent(data.story);
                } catch (err) {}
            });
        });
    }

    function _update_working_copy() {
        var uuid = _autosave_base_data.uuid;
        var story = $('[data-id="story"]').val();
        ajaxlib.setLocalKey(uuid, story);
    }

    function _load_story(uuid) {
        return new Promise(function(_callback) {
            ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/', ajaxlib.fetchAuthHeader()).Get().then(
                function(data) {
                    _fill_form(data, uuid).then(_callback);
                }).catch(_show_error);
        });
    }

    function _auto_save() {
        var is_dirty = [];
        var uuid = _autosave_base_data.uuid;
        var formData = {};
        Object.keys(_autosave_base_data).forEach(function(key) {
            if ($('[data-id="' + key + '"]').val() !== undefined && $('[data-id="' + key + '"]').val() !== null) {
                console.log($('[data-id="' + key + '"]').val(), _autosave_base_data[key], key);
                is_dirty.push($('[data-id="' + key + '"]').val() != _autosave_base_data[key]);
                formData[key] = $('[data-id="' + key + '"]').val();
            }
        });
        console.log(is_dirty);
        if (is_dirty.indexOf(true) != -1) {
            _is_not_dirty = false;
            // Changes are present. Let's Update
            ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/autosave/', ajaxlib.fetchAuthHeader()).Post(formData).then(function(data) {
                toastr.success(data.message);
                _autosave_base_data = data.data;
                _is_not_dirty = true;
            });
        } else {
            _is_not_dirty = true;
        }
    }

    function _save_to_draft(uuid) {
        var formData = {};
        Object.keys(_autosave_base_data).forEach(function(key) {
            formData[key] = $('[data-id="' + key + '"]').val();
        });
        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/save/draft/', ajaxlib.fetchAuthHeader()).Post(formData).then(function(data) {
            toastr.success(data.message);
            try {
                clearInterval(_timer);
            } catch (e) {}
            _is_not_dirty = true;
            ajaxlib.resetLocalKey(uuid).then(function() {
                _redirect_dashboard();
            });
        }).catch(_show_error);
    }

    function _save_and_publish(uuid, mode) {
        mode = mode ? mode.replace('publish', '').replace('-', '') : '';
        var formData = {};
        Object.keys(_autosave_base_data).forEach(function(key) {
            formData[key] = $('[data-id="' + key + '"]').val();
        });
        ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/save/draft/', ajaxlib.fetchAuthHeader()).Post(formData).then(function(data) {
            try {
                clearInterval(_timer);
            } catch (e) {}
            _is_not_dirty = true;
            ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/publish/' + mode, ajaxlib.fetchAuthHeader()).Post().then(function(data) {
                toastr.success(data.message);
                _is_not_dirty = true;
                ajaxlib.resetLocalKey(uuid).then(function() {
                    _redirect_dashboard();
                });
            }).catch(_show_error);
        }).catch(_show_error);
    }

    function _pub(e, who) {
        who = who ? 'pool' : 'pt';
        var uuid = __get_uuid(e);

        var type = (who === 'pool') ? 'Accept' : 'Publish';

        __disp_block({
            title: type + ' Story',
            confirmButtonText: type + '!',
            cancelTitle: 'Story not ' + type + 'ed!',
            failedText: 'Failed to ' + type + '!',
            successTitle: 'Story ' + type + 'ed!',
            successText: 'The Story is ' + type + 'ed successfully',
            path: _baseURL + '/stories/' + uuid + '/publish/' + who + '/'
        });
    }

    function _publish_only(e) {
        return _pub(e);
    }

    function _send_to_pool(e) {
        return _pub(e, true);
    }

    function _flag_story(e) {
        var uuid = __get_uuid(e);

        _myswal({
            title: 'Flag Story',
            input: 'textarea',
            inputPlaceholder: 'Enter a Flag Message',
            inputValidator: function(value) {
                return new Promise(function(resolve) {
                    if (value.trim() === '') {
                        resolve('Please Enter a short Message');
                    } else if (value.trim().length > 500) {
                        resolve('Message is too long. Please reduce the summary size. Max Length: 500 Characters');
                    } else {
                        resolve('');
                    }
                });
            },
            showCancelButton: true,
            confirmButtonText: 'Mark Flag',
            showLoaderOnConfirm: true,
            preConfirm: function(flag_message) {
                ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/flag/', ajaxlib.fetchAuthHeader()).Post({
                    flag_message: flag_message
                }).then(function(response) {
                    return response;
                }).catch(function(err) {
                    _myswal.showValidationError(
                        'Request failed: ' + err.detail
                    );
                });
            },
            allowOutsideClick: function() { return !_myswal.isLoading(); },
        }).then(_cbf({
            'type': 'Flagged',
            'successText': 'The Story is flagged and sent to Editor'
        }));
    }

    function _init_autosave() {
        // Autosave every 20 seconds
        _timer = setInterval(_auto_save, 20000);
    }

    function _get_current_active() {
        return _current_active;
    }

    function _get_visited_mark_new() {
        return !_visited_mark_new;
    }

    function _get_visited_mark_accepted() {
        return !_visited_mark_accepted;
    }

    function _get_visited_mark_email() {
        return !_visited_mark_email;
    }

    function _get_visited_mark_flag() {
        return !_visited_mark_flag;
    }

    function _get_visited_mark_pending() {
        return !_visited_mark_pending;
    }

    function _save_user(_cb) {
        return function(data) {
            _user = data.data;
            _cb();
        };
    }

    function _get_user_views() {
        return _user.view;
    }

    function _get_user() {
        return _user;
    }

    function _update_dd(data) {
        data = data.data;
        $('[data-id="sub_category"]').each(function(i, el) {
            var html = '<option data-key="" value="">Select Sub-Category</option>';
            Object.keys(data).forEach(function(slug) {
                html += '<option data-key="' + slug + '" value="' + slug + ';' + data[slug] + '">' + data[slug] + '</option>';
            });
            $(el).html(html);
        });
    }

    function _update_st(data) {
        data = data.data;
        $('[data-id="sub_topic"]').each(function(i, el) {
            var html = '<option data-key="" value="">Select Sub-Topic</option>';
            Object.keys(data).forEach(function(slug) {
                html += '<option data-key="' + slug + '" value="' + slug + ';' + data[slug] + '">' + data[slug] + '</option>';
            });
            $(el).html(html);
        });
    }

    function _load_sub_cateogories(e) {
        try {
            e.preventDefault();
            e.stopPropagation();
        } catch (err) {}
        var slug = $(e.target).val().split(';').shift();
        if (slug === undefined) {
            slug = e;
        }
        if (slug !== "") {
            ajaxlib.AJAX(_baseURL + '/stories/subcategories/' + slug + '/', ajaxlib.fetchAuthHeader()).Get().then(_update_dd).catch(_show_error);
        }
    }

    function _load_sub_topics(e) {
        try {
            e.preventDefault();
            e.stopPropagation();
        } catch (err) {}
        var slug = $(e.target).val().split(';').shift();
        if (slug === undefined) {
            slug = e;
        }
        if (slug !== "") {
            ajaxlib.AJAX(_baseURL + '/stories/subtopics/' + slug + '/', ajaxlib.fetchAuthHeader()).Get().then(_update_st).catch(_show_error);
        }
    }

    function _mark_uploaded(uuid, show_remove, _cbA, _cbB, data_name, _prepend) {
        _prepend = _prepend ? true : false;
        data_name = data_name || 'id';
        show_remove = show_remove ? true : false;
        _cbA = typeof _cbA === 'function' ? _cbA : function(data) {};
        _cbB = typeof _cbB === 'function' ? _cbB : function(uuid) {};
        return function(data) {
            data = data.data;
            var obj = '<span class="badge badge-success"><i class="mdi mdi-check-circle"></i>&nbsp;Uploaded</span>&nbsp;';

            if (show_remove) {
                obj += '<a data-action="remove_inline" data-id="' + data.id + '" href="#" class="badge badge-danger">' +
                    '<i class="mdi mdi-close-circle"></i>&nbsp;Remove' +
                    '</a>';
            }
            $('[data-' + data_name + '="' + uuid + '"]').find('.progress').remove();
            if (_prepend) {
                $('[data-' + data_name + '="' + uuid + '"]').prepend(obj);
            } else {
                $('[data-' + data_name + '="' + uuid + '"]').append(obj);
            }
            $('[data-' + data_name + '="' + uuid + '"]').removeClass('pending');
            if (show_remove) {
                $('[data-action="remove_inline"]').off().on('click', applib.removeInlineImage(_cbB));
            }
            // Finally Call the callback
            _cbA(data);
        };
    }

    function _mark_failed(uuid, data_name, _prepend) {
        _prepend = _prepend ? true : false;
        data_name = data_name || 'id';
        return function(err) {
            $('[data-' + data_name + '="' + uuid + '"]').find('.progress').remove();
            if (_prepend) {
                $('[data-' + data_name + '="' + uuid + '"]').prepend('<span class="badge badge-danger"><i class="mdi mdi-close-circle"></i>&nbsp;Failed to Upload</span>');
            } else {
                $('[data-' + data_name + '="' + uuid + '"]').append('<span class="badge badge-danger"><i class="mdi mdi-close-circle"></i>&nbsp;Failed to Upload</span>');
            }
            console.log('Failed to Upload');
            _show_error(err);
        };
    }

    function _upload_cover_image(formData, progress_cb) {
        var uuid = _autosave_base_data.uuid;
        if (uuid === undefined || uuid === null) {
            uuid = formData.get('uuid');
        }
        return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/upload/', ajaxlib.fetchAuthHeader()).Post(formData, true, progress_cb);
    }

    function _upload_inline_image(formData, progress_cb) {
        var uuid = _autosave_base_data.uuid;
        return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/upload/extras/', ajaxlib.fetchAuthHeader()).Post(formData, true, progress_cb);
    }

    function _prepare_download(e) {
        var uuid = __get_uuid(e);

        ajaxlib.AJAX(_baseURL + '/templates/', ajaxlib.fetchAuthHeader()).Get().then(function(data) {
            data = data.data;
            var html = '<hr/><div class="row" id="sw-bb">' +
                '<div class="col-12">' +
                '<div class="d-flex px-2">' +
                '<div class="custom-control custom-checkbox">' +
                '<input id="tmps_all" value="" class="custom-control-input" type="checkbox">' +
                '<label class="custom-control-label" for="tmps_all">SELECT ALL</label>' +
                '</div>' +
                '</div><hr></div>' +
                '<div class="col-12">';
            data.forEach(function(elem) {
                var tmp = '<div class="d-flex px-2 pb-2">' +
                    '<div class="custom-control custom-checkbox">' +
                    '<input data-check="template" id="tmp_' + elem.pk + '" type="checkbox" class="custom-control-input" name="template[]" value="' + elem.pk + '"/>' +
                    '<label class="custom-control-label" for="tmp_' + elem.pk + '">' + elem.template_name + '&nbsp;<span class="badge badge-' + (elem.template_ext === 'T' ? 'info' : 'success') + '">' + (elem.template_ext === 'T' ? 'TXT' : 'XML') + '</span></label>' +
                    '</div>' +
                    '</div>';
                html += tmp;
            });
            html += '</div></div><hr/>';
            _myswal({
                title: '<i class="mdi mdi-cloud-download"></i>&nbsp;Choose the Templates',
                html: html,
                showCancelButton: true,
                confirmButtonText: '<i class="mdi mdi-cloud-download"></i>&nbsp;Download',
                showLoaderOnConfirm: true,
                onBeforeOpen: function() {
                    $('#tmps_all').off().on('change', function(e) {
                        $('[data-check="template"]').prop('checked', $(this)[0].checked);
                    });
                },
                preConfirm: function() {
                    var formData = new FormData();
                    $('[name="template[]"]:checked').each(function(i, el) {
                        formData.append('template', $(el).val());
                    });
                    return ajaxlib.AJAX(_baseURL + '/stories/' + uuid + '/download/init/', ajaxlib.fetchAuthHeader()).Post(formData, true).then(function(data) {
                        return data;
                    }).catch(function(err) {
                        var e = '';
                        try {
                            e = ': ' + err.detail;
                        } catch (errn) {}
                        _myswal.showValidationError(
                            'Request failed' + e
                        );
                    }).then(function(data) {
                        var key = data.data;
                        toastr.success("File Download started");
                        document.location.href = '/download/' + uuid + '/?key=' + key;
                    });
                }
            });
        }).catch(_show_error);
    }

    function _cancel_dd(_base, locked_obj) {
        function _wrap(e) {
            try {
                e.preventDefault();
                e.stopPropagation();
            } catch (err) {
                _base = e;
            }
            $(this).html(_base).addClass('js-show-edit').removeClass('js-edit-mode').removeClass('locked');
            $(this).on('click', applib.showEditDD);
            if (locked_obj !== undefined) {
                var l = locked_obj;
                locked_obj = undefined;
                return _wrap.bind(l.obj)(l.base);
            }
        }
        return _wrap;
    }

    function _commit_dd(_base, _self) {
        return function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (_root_tmpdata === null) {
                _root_tmpdata = {};
            }
            var key = $(_self).data('key');
            var dat = $(_self).find('.dd').first().val();
            _root_tmpdata[key] = dat;
            var next = $(_self).data('next');
            var submit_path = $(_self).data('submit');
            if (next !== undefined) {
                var nextslug = $(_self).find('.dd').first().val().split(';').shift();
                if (nextslug !== '') {
                    nextslug += '/';
                }
                var ne = $('[data-key="' + next + '"]')[0];
                $(_self).addClass('locked');
                ajaxlib.AJAX(_baseURL + '/stories/' + next + '/' + nextslug, ajaxlib.fetchAuthHeader()).Get().then(_disp_dd.bind(ne)({ obj: _self, base: _base })).catch(_show_error);
            } else if (submit_path !== undefined) {
                $(_self).addClass('locked');
                var rd = $(_self).data('redirect');
                var rm = _refresh_page;
                if (rd !== undefined) {
                    rm = _redirect_page(rd);
                }
                ajaxlib.AJAX(_baseURL + submit_path, ajaxlib.fetchAuthHeader()).Post(_root_tmpdata).then(rm).catch(_show_error);
            }
        };
    }

    function _disp_dd(locked_obj) {
        var _self = this;
        return function(data) {
            data = data.data;
            var _base = $(this).html();
            var _new = $('<select class="dd form-control col-3"/>');
            var html = '<option data-key="" value="">Select one Option</option>';
            Object.keys(data).forEach(function(slug) {
                html += '<option data-key="' + slug + '" value="' + slug + ';' + data[slug] + '">' + data[slug] + '</option>';
            });
            _new.html(html);
            $(this).html(_new);
            var confirmBtn = $(_self).data('confirm') || 'Update';
            $(this).append($('<span class="badge badge-success js-commit"><i class="mdi mdi-check"></i> ' + confirmBtn + '</span>'));
            $(this).append($('<span class="badge badge-danger js-close"><i class="mdi mdi-close-box"></i> Cancel</span>'));
            $(this).off().removeClass('js-show-edit').addClass('js-edit-mode');
            $(this).find('.js-close').off().on('click', _cancel_dd(_base, locked_obj).bind(_self));
            $(this).find('.js-commit').off().on('click', _commit_dd(_base, _self));
        }.bind(_self);
    }

    function _disp_tb(locked_obj) {
        var _self = this;
        return function(data) {
            data = data.data;
            var _base = $(this).html();
            var _new = $('<input type="' + data.type + '" class="dd form-control col-3" name="' + data.name + '" value="' + data.value + '" />');
            $(this).html(_new);
            $(this).append($('<span class="badge badge-success js-commit"><i class="mdi mdi-check"></i> Update</span>'));
            $(this).append($('<span class="badge badge-danger js-close"><i class="mdi mdi-close-box"></i> Cancel</span>'));
            $(this).off().removeClass('js-show-edit').addClass('js-edit-mode');
            $(this).find('.js-close').off().on('click', _cancel_dd(_base, locked_obj).bind(_self));
            $(this).find('.js-commit').off().on('click', _commit_dd(_base, _self));
        }.bind(_self);
    }

    function _show_edit_dd(e) {
        e.preventDefault();
        e.stopPropagation();
        //if (_user.group == 'PT') {
        var mode = $(this).data('mode') || 'dd';
        var key = $(this).data('key');
        var slug = $(this).data('slug') || '';
        if (mode === 'dd') {
            if (slug !== '') {
                slug += '/';
            }
            ajaxlib.AJAX(_baseURL + '/stories/' + key + '/' + slug, ajaxlib.fetchAuthHeader()).Get().then(_disp_dd.bind(this)(undefined)).catch(_show_error);
        } else if (mode == 'tb') {
            _disp_tb.bind(this)(undefined)({ data: { type: 'text', name: key, value: slug } });
        }
        //} else {
        //    _show_error({detail: "You don't have Rights"});
        //}
    }

    function _open_modal(dataObj) {
        var modal = $('<div class="modal fade" id="modal-diff" tabindex="-1" role="dialog" aria-labelledby="DiffModalLabel" aria-hidden="true"></div>');
        var modalDialog = $('<div class="modal-dialog modal-lg"></div>');
        var modalContent = $('<div class="modal-content"></div>');
        var modalHeader = $('<div class="modal-header"></div>');
        var modalCloseBtn = $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>');
        var modalTitle = $('<h4 class="modal-title" id="DiffModalLabel">Modal title</h4>');
        var modalBody = $('<div class="modal-body"></div>');
        var modalFooter = $('<div class="modal-footer"></div>');
        var modalFooterCloseBtn = $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>');
        var modalFooterAcceptBtn = $('<button type="button" id="btn-modal-accept" class="btn btn-primary">Save changes</button>');

        modalTitle.html(dataObj.title);
        modalTitle.appendTo(modalHeader);
        modalCloseBtn.appendTo(modalHeader);
        modalHeader.appendTo(modalContent);
        modalBody.html(dataObj.body);
        modalBody.appendTo(modalContent);
        if (dataObj.needFooter) {
            if (dataObj.customFooter) {
                modalFooter.html(dataObj.customFooter);
            } else {
                if (dataObj.needDismissBtn) {
                    modalFooterCloseBtn.html(dataObj.dismissBtnText);
                    modalFooterCloseBtn.appendTo(modalFooter);
                }
                modalFooterAcceptBtn.html(dataObj.acceptBtnText);
                modalFooterAcceptBtn.appendTo(modalFooter);
            }
            modalFooter.appendTo(modalContent);
        }
        modalContent.appendTo(modalDialog);
        modalDialog.appendTo(modal);

        return modal;
    }

    function _init_diff(blkOld, blkNew, isString) {
        isString = isString ? true : false;
        if (Diff !== undefined) {
            var dataOld = $(blkOld).html();
            var dataNew = $(blkNew).html();
            if (isString) {
                dataOld = blkOld;
                dataNew = blkNew;
            }
            var diff = Diff.diffChars(dataOld, dataNew);
            return Object.freeze({
                execute: function() {
                    var v = []
                    var e = diff.filter(function(entry) {
                        return entry.added || entry.removed;
                    });
                    if (e.length) {
                        v = diff;
                    }
                    return new Promise(function(_callback) {
                        _callback(v);
                    });
                }
            });
        }
    }

    function _pretty_print_diff(target) {
        return function(diff) {
            var raw = '';
            var crdBlk = '<div class="card mb-0">' +
                '<div class="card-body ribbon-box p-2 pl-3">' +
                '<div data-hide class="ribbon ribbon-dark">Preview</div><div id="card-prev-container" class="mb-0 clear">' +
                '</div></div></div>';
            var $targetBlk = $('<div class="m-0 p-0 d-none" id="content-preview">');
            var loader = $('<div class="pt-2 pb-3 table loading" data-dt-loader="loader">');
            loader.append($('<img src="/static/intradmin/assets/ajax-loader.gif" alt="" />'));
            $(target).html(crdBlk);

            $('#card-prev-container').append(loader);
            $('#card-prev-container').append($targetBlk);
            applib.startDtLoader();
            return new Promise(function(_cb) {
                setTimeout(function() {
                    diff.forEach(function(part) {
                        try {
                            if (part.added) {
                                raw += '<span class="part-added">' + part.value + '</span>';
                            } else if (part.removed) {
                                raw += '<span class="part-removed">' + part.value + '</span>';
                            } else {
                                raw += '<span class="part-nochange">' + part.value + '</span>';
                            }
                        } catch (err) {
                            console.log(part);
                        }
                    });
                    $targetBlk.html(raw);
                    applib.stopDtLoader();
                    $targetBlk.removeClass('d-none');
                    _cb(true);
                }, 200);
            });
        };
    }

    window.applib = Object.freeze({
        acceptStory: _accept_story,
        addAdditional: _add_additional,
        amendStory: _amend_story,
        archiveStory: _archive_story,
        baseURL: _baseURL,
        createStory: _create_story,
        editStory: _edit_story,
        fetchStories: _fetch_stories,
        flagStory: _flag_story,
        getBtn: _get_btn,
        getCurrentActive: _get_current_active,
        getMarkFlag: _get_visited_mark_flag,
        getMarkNew: _get_visited_mark_new,
        getMarkPending: _get_visited_mark_pending,
        getMarkAccepted: _get_visited_mark_accepted,
        getMarkEmail: _get_visited_mark_email,
        getUser: _get_user,
        getViews: _get_user_views,
        getUUID: __get_uuid,
        initAutoSave: _init_autosave,
        initDiff: _init_diff,
        isNotDirty: function() { return _is_not_dirty; },
        loadData: _load_data,
        loadStory: _load_story,
        loadSubCategories: _load_sub_cateogories,
        login: _login,
        logout: _logout,
        markFailed: _mark_failed,
        markApproved: _mark_approved,
        markRead: _mark_read,
        markUnread: _mark_unread,
        markUploaded: _mark_uploaded,
        openModal: _open_modal,
        padn: _padn,
        prepareDownload: _prepare_download,
        prettyPrintDiff: _pretty_print_diff,
        publishStory: _publish_only,
        publishToANI: _publish_to_ani,
        sendStoryToPool: _send_to_pool,
        redirectDashboard: _redirect_dashboard,
        redirectMediaDashboard: _redirect_media_dashboard,
        redirectANIDashboard: _redirect_ani_dashboard,
        releaseStory: _release_story,
        reloadCurrent: _reload_current,
        removeInlineImage: _remove_inline_image,
        render_dt: render_dt,
        render_stat: render_stat,
        saveAndPublish: _save_and_publish,
        setDT: _set_dt,
        startDtLoader: _start_dt_loader,
        stopDtLoader: _stop_dt_loader,
        showError: _show_error,
        showToast: _show_toast,
        showLogin: _redirect_login,
        saveToDraft: _save_to_draft,
        saveUser: _save_user,
        sendFTP: _send_ftp,
        setIsDirty: function() { _is_not_dirty = false; },
        setupListener: _setup_listener,
        showEditDD: _show_edit_dd,
        updateWorkingCopy: _update_working_copy,
        uploadCoverImage: _upload_cover_image,
        uploadInlineImage: _upload_inline_image,
        uuidv4: uuidv4,
        viewStory: _view_story,
        loadSubTopics: _load_sub_topics,
    });

})(window, document, jQuery, window.ajaxlib, window.appconfig, window.Diff);
